module.exports = __webpack_public_path__ + "static/media/cara_logo_letters.05eda5eb.png";